import React, { useState } from 'react';
import { FormGroup, Input} from 'reactstrap';
import { FormLabel, FormValue } from './FormLabel';
import { useFormikContext } from 'formik';
import { useEdit } from '../../Services/EditContext';
import { useEffect } from 'react';
import { endpoints } from '../../utils/Constants';
import { useFetchCached } from '../../Services/fetchApi';

const Inexclusions = ({ noEdit }) => {
    const [inexclusions, loadingInexcludions, errorInexclusion] = useFetchCached(endpoints.inExclusions);
    const [edit] = useEdit();
    const { values, setFieldValue } = useFormikContext();
    const [inEx, setInex] = useState([]);
    const { inclusions, exclusions } = values;
    useEffect(() => {
        const ins = inclusions ? inclusions.split(',') : [];
        const inex = inexclusions instanceof Array  ? inexclusions.map((y) => {
            const set = ins.find((x) => y.name === x);
            return { name: y.name, set: set ? true : false };

        }) : [];
        setInex(inex);
        if (!inclusions && !exclusions) {
            const inclusions = inex.filter(x => x.set).map(y => y.name).join(',');
            const exclusions = inex.filter(x => !x.set).map(y => y.name).join(',');
            setFieldValue('inclusions', inclusions);
            setFieldValue('exclusions', exclusions);
        }

    }, [inexclusions, inclusions, exclusions,setFieldValue]);
    const handleChange = (a, b) => {
        const newInEx = inEx.map(x => x.name === a ? { name: x.name, set: b } : x);
        setInex(newInEx);
        const inclusions = newInEx.filter(x => x.set).map(y => y.name).join(',');
        const exclusions = newInEx.filter(x => !x.set).map(y => y.name).join(',');
        setFieldValue('inclusions', inclusions);
        setFieldValue('exclusions', exclusions);
    }

    return ((!noEdit && edit) || loadingInexcludions) && inEx ? <React.Fragment>
        <FormGroup><FormLabel>Inclusions:</FormLabel></FormGroup>
        {
        inEx.map((x, i) => {
            return <FormGroup key={i} check inline>
                {errorInexclusion ? <FormLabel>Error Loading In/Exclusions</FormLabel> : null}

                <FormLabel check htmlFor={x.name} style={{ display: 'block' }}>
                    <Input id={x.name} name={x.name} type='checkbox' onChange={(e) => handleChange(x.name, e.currentTarget.checked)} checked={x.set} />
                    {x.name}
                </FormLabel></FormGroup>
        })
        }
       
    </React.Fragment> : <React.Fragment>
            {values.inclusions? <FormLabel>Inclusions:</FormLabel>:null}
            <FormValue>{values.inclusions}</FormValue>
            {values.exclusions ? <FormLabel>Exclusions:</FormLabel> : null}
            <FormValue>{values.exclusions}</FormValue>
        </React.Fragment>
}
export default Inexclusions;